import { Button, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { triggerSavedSearchRun } from "../../../../redux/features/savedSearchView/savedSearchViewSlice";
import { useRuleQuery } from "../../../../components/QueryBuilder/hooks/useRuleQuery";
import SaveReportModal from "../../../advancedSearch/components/SaveReportModal";
import SavedSearchDetailsPopup from "./SavedSearchDetailsPopup";

export default function SavedSearchHeader({ ruleId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: rule } = useRuleQuery(ruleId);
  const [detailsOpen, { open: openDetails, close: closeDetails }] =
    useDisclosure(false);

  return (
    <>
      <Group justify="space-between">
        <Group ml="md">
          <Button variant="default" onClick={() => navigate(-1)}>
            Back
          </Button>
          <Button variant="filled" color="primary.7" onClick={openDetails}>
            Details
          </Button>
        </Group>
        <Group gap="md" mr="md">
          {rule && rule.type !== "BASIC" && (
            <SaveReportModal
              ruleId={ruleId}
              defaultName={rule.name ?? ""}
              disabled={rule.hasSavedData === true}
            />
          )}
          <Button
            variant="filled"
            color="primary.7"
            onClick={() => dispatch(triggerSavedSearchRun())}
          >
            Run search
          </Button>
        </Group>
      </Group>

      <SavedSearchDetailsPopup
        ruleId={ruleId}
        opened={detailsOpen}
        onClose={closeDetails}
      />
    </>
  );
}
